// Dari + Pashto translation dictionary for رستورانت پلاس
export const translations = {
  dari: {
    appName: "رستورانت پلاس",
    tagline: "سیستم مدیریت کامل رستورانت",
    // Auth
    login: "ورود",
    logout: "خروج",
    username: "نام کاربری",
    password: "رمز عبور",
    rememberMe: "مرا به خاطر بسپار",
    demoAccounts: "حساب‌های دموی",
    loginButton: "ورود به سیستم",
    invalidCreds: "نام کاربری یا رمز اشتباه است",
    // Sidebar
    dashboard: "داشبورد",
    tables: "میزها",
    newOrder: "سفارش جدید",
    kitchen: "آشپزخانه",
    cashier: "دخل",
    menu: "منوی غذا",
    expenses: "مصارف",
    debtors: "قرضداران",
    dailySales: "گزارش فروش روزانه",
    bestSelling: "غذاهای پرفروش",
    monthlyProfit: "مفاد و ضرر ماهانه",
    users: "کاربران",
    settings: "تنظیمات",
    reservations: "رزرویشن",
    inventory: "انبار",
    stockItem: "ماده اولیه",
    stockIn: "ورودی انبار",
    stockOut: "مصرف انبار",
    stockAdjust: "اصلاح موجودی",
    lowStock: "موجودی کم",
    unit: "واحد",
    currentQty: "موجودی فعلی",
    minQty: "حداقل موجودی",
    costPerUnit: "قیمت هر واحد",
    supplier: "تامین‌کننده",
    lastRestocked: "آخرین تامین",
    partySize: "تعداد مهمان",
    time: "ساعت",
    pending: "در انتظار",
    confirmed: "تایید شده",
    seated: "نشسته",
    noShow: "حاضر نشد",
    reservationsToday: "رزروهای امروز",
    addReservation: "افزودن رزرو",
    addStock: "افزودن ماده",
    addTx: "ثبت تراکنش",
    txHistory: "تاریخچه تراکنش‌ها",
    balance: "موجودی",
    // Common
    save: "ذخیره",
    cancel: "لغو",
    delete: "حذف",
    edit: "ویرایش",
    add: "افزودن",
    search: "جستجو",
    print: "چاپ",
    export: "خروجی گرفتن",
    confirm: "تایید",
    actions: "عملیات",
    name: "نام",
    phone: "تلفن",
    amount: "مبلغ",
    date: "تاریخ",
    status: "وضعیت",
    total: "مجموع",
    paid: "پرداخت شده",
    unpaid: "پرداخت نشده",
    debt: "قرض",
    discount: "تخفیف",
    tax: "مالیات",
    service: "خدمات",
    subtotal: "جمع جزء",
    quantity: "تعداد",
    price: "قیمت",
    notes: "یادداشت",
    description: "توضیحات",
    category: "کتگوری",
    type: "نوع",
    waiter: "گارسون",
    cashierLabel: "حسابدار",
    table: "میز",
    capacity: "ظرفیت",
    section: "بخش",
    role: "نقش",
    user: "کاربر",
    address: "آدرس",
    customer: "مشتری",
    today: "امروز",
    yesterday: "دیروز",
    currency: "افغانی",
    afn: "AFN",
    // Statuses
    available: "خالی",
    occupied: "مصروف",
    reserved: "رزرو شده",
    cleaning: "نیاز به پاک‌کاری",
    draft: "پیش‌نویس",
    sent: "ارسال به آشپزخانه",
    preparing: "در حال آماده‌سازی",
    ready: "آماده",
    served: "تحویل شده",
    cancelled: "لغو شده",
    new: "جدید",
    active: "فعال",
    partial: "پرداخت ناقص",
    overdue: "تاخیر",
    // Order types
    dineIn: "داخل رستورانت",
    takeaway: "بیرون‌بر",
    delivery: "دلیوری",
    // Payment methods
    cash: "نقد",
    card: "کارت",
    mobile: "پرداخت موبایلی",
    bank: "انتقال بانکی",
    // Dashboard
    salesToday: "فروش امروز",
    ordersToday: "تعداد سفارش‌ها",
    activeOrders: "سفارش‌های فعال",
    busyTables: "میزهای مصروف",
    expenseToday: "مصارف امروز",
    debtToday: "قرض امروز",
    profitToday: "مفاد تخمینی",
    itemsSold: "غذاهای فروخته‌شده",
    salesTrend: "روند فروش ۷ روز اخیر",
    topItems: "پرفروش‌ترین غذاها",
    revenueExpense: "درآمد در برابر مصارف",
    recentOrders: "سفارش‌های اخیر",
    recentDebtors: "قرضداران اخیر",
    goToCashier: "رفتن به دخل",
    viewKitchen: "دیدن آشپزخانه",
    addExpense: "افزودن مصرف",
    addFood: "افزودن غذا",
    // Tables
    addTable: "افزودن میز",
    tableNumber: "شماره میز",
    allSections: "همه بخش‌ها",
    openOrder: "باز کردن سفارش",
    startOrder: "شروع سفارش",
    markClean: "علامت‌گذاری به عنوان پاک",
    // Order screen
    selectTable: "انتخاب میز",
    orderType: "نوع سفارش",
    customerName: "نام مشتری",
    customerPhone: "تلفن مشتری",
    addToCart: "افزودن به سبد",
    sendToKitchen: "ارسال به آشپزخانه",
    saveDraft: "ذخیره پیش‌نویس",
    cart: "سبد سفارش",
    emptyCart: "سبد خالی است",
    allCategories: "همه دسته‌ها",
    // Kitchen
    startPreparing: "شروع آماده‌سازی",
    markReady: "علامت‌گذاری آماده",
    markServed: "تحویل شد",
    noActiveOrders: "سفارش فعالی وجود ندارد",
    elapsed: "زمان گذشته",
    // Cashier
    applyDiscount: "اعمال تخفیف",
    paymentMethod: "روش پرداخت",
    receivePayment: "دریافت پرداخت",
    splitBill: "تقسیم بل",
    printReceipt: "چاپ رسید",
    receivedAmount: "مبلغ دریافت شده",
    change: "بازگشتی",
    remaining: "باقی‌مانده",
    // Menu
    addItem: "افزودن غذا",
    addCategory: "افزودن دسته",
    available_: "موجود",
    unavailable: "ناموجود",
    image: "تصویر",
    prepTime: "زمان آماده‌سازی (دقیقه)",
    costPrice: "قیمت تمام شده",
    // Expenses
    expenseCategory: "کتگوری مصرف",
    paidBy: "پرداخت‌کننده",
    // Debtors
    debtorName: "نام قرضدار",
    totalDebt: "مجموع قرض",
    totalPaid: "مجموع پرداخت",
    remainingDebt: "باقی‌مانده قرض",
    addPayment: "افزودن پرداخت",
    debtHistory: "تاریخچه قرض",
    // Reports
    dailyReport: "گزارش روزانه",
    monthlyReport: "گزارش ماهانه",
    revenue: "درآمد",
    grossProfit: "مفاد ناخالص",
    netProfit: "مفاد خالص",
    profitMargin: "حاشیه مفاد",
    avgOrder: "میانگین سفارش",
    byMethod: "بر اساس روش پرداخت",
    byCategory: "بر اساس دسته",
    hourlyChart: "نمودار ساعتی",
    // Users
    addUser: "افزودن کاربر",
    lastLogin: "آخرین ورود",
    // Settings
    restaurantInfo: "اطلاعات رستورانت",
    receiptSettings: "تنظیمات رسید",
    financialSettings: "تنظیمات مالی",
    languageSettings: "تنظیمات زبان",
    restaurantName: "نام رستورانت",
    receiptFooter: "متن پایان رسید",
    receiptWidth: "عرض چاپگر حرارتی",
    taxEnabled: "فعال‌سازی مالیات",
    taxPercent: "درصد مالیات",
    serviceEnabled: "فعال‌سازی خدمات",
    servicePercent: "درصد خدمات",
    defaultLanguage: "زبان پیش‌فرض",
    empty: "موردی یافت نشد",
    loading: "در حال بارگذاری...",
    confirmDelete: "آیا از حذف اطمینان دارید؟",
    success: "با موفقیت انجام شد",
    error: "خطا رخ داد",
    sessionExpired: "نشست شما منقضی شد — لطفاً دوباره وارد شوید",
    networkError: "خطای شبکه — اتصال اینترنت را بررسی کنید",
    retry: "تلاش مجدد",
    loadError: "بارگذاری ناموفق بود",
    welcome: "خوش آمدید",
  },

  pashto: {
    appName: "ریسټورانټ پلس",
    tagline: "د بشپړ ریسټورانټ مدیریت سیسټم",
    login: "ننوتل",
    logout: "وتل",
    username: "د کارن نوم",
    password: "پټنوم",
    rememberMe: "ما په یاد ولره",
    demoAccounts: "ډیمو حسابونه",
    loginButton: "سیسټم ته ننوتل",
    invalidCreds: "د کارن نوم یا پټنوم تېروتنه ده",
    dashboard: "ډشبورډ",
    tables: "مېزونه",
    newOrder: "نوی فرمایش",
    kitchen: "پخلنځی",
    cashier: "دخل",
    menu: "د خوړو مینو",
    expenses: "لګښتونه",
    debtors: "پوروړي",
    dailySales: "د ورځني خرڅلاو راپور",
    bestSelling: "ډېر پلورل شوي خواړه",
    monthlyProfit: "میاشتنی ګټه او تاوان",
    users: "کاروونکي",
    settings: "تنظیمات",
    reservations: "ریزرویشن",
    inventory: "ګودام",
    stockItem: "خام مواد",
    stockIn: "ګودام ته داخلیدل",
    stockOut: "د ګودام مصرف",
    stockAdjust: "د موجودي سمون",
    lowStock: "کمه موجودي",
    unit: "واحد",
    currentQty: "اوسنۍ موجودي",
    minQty: "لږ تر لږه موجودي",
    costPerUnit: "د یوه واحد بیه",
    supplier: "وړوونکی",
    lastRestocked: "وروستی تامین",
    partySize: "د مېلمنو شمېر",
    time: "وخت",
    pending: "په تمه",
    confirmed: "تایید شوی",
    seated: "ناست",
    noShow: "حاضر نه شو",
    reservationsToday: "د نن ریزرویشنونه",
    addReservation: "د ریزرویشن زیاتول",
    addStock: "د مادې زیاتول",
    addTx: "د راکړې ورکړې ثبتول",
    txHistory: "د راکړو ورکړو تاریخچه",
    balance: "موجودي",
    save: "خوندي کول",
    cancel: "لغوه کول",
    delete: "حذف کول",
    edit: "سمول",
    add: "زیاتول",
    search: "لټون",
    print: "چاپ",
    export: "صادرول",
    confirm: "تایید",
    actions: "عملیات",
    name: "نوم",
    phone: "تلیفون",
    amount: "مقدار",
    date: "نېټه",
    status: "حالت",
    total: "ټول",
    paid: "ورکړل شوی",
    unpaid: "نه دی ورکړل شوی",
    debt: "پور",
    discount: "تخفیف",
    tax: "مالیه",
    service: "خدمت",
    subtotal: "فرعي ټول",
    quantity: "شمېر",
    price: "بیه",
    notes: "یادښت",
    description: "تشریح",
    category: "کټګوري",
    type: "ډول",
    waiter: "ګارسون",
    cashierLabel: "حسابدار",
    table: "مېز",
    capacity: "ظرفیت",
    section: "برخه",
    role: "رول",
    user: "کاروونکی",
    address: "پته",
    customer: "پېرودونکی",
    today: "نن",
    yesterday: "پرون",
    currency: "افغانۍ",
    afn: "AFN",
    available: "خالي",
    occupied: "بوخت",
    reserved: "ساتل شوی",
    cleaning: "د پاکولو اړتیا",
    draft: "مسوده",
    sent: "پخلنځي ته لېږل شوی",
    preparing: "چمتو کېږي",
    ready: "چمتو",
    served: "وړاندې شوی",
    cancelled: "لغوه شوی",
    new: "نوی",
    active: "فعال",
    partial: "نیمګړی ورکړل شوی",
    overdue: "ځنډېدلی",
    dineIn: "په رستورانټ کې",
    takeaway: "د وړلو لپاره",
    delivery: "ډېلیوري",
    cash: "نقده",
    card: "کارت",
    mobile: "د موبایل تادیه",
    bank: "د بانک لېږد",
    salesToday: "د نن خرڅلاو",
    ordersToday: "د نن فرمایشونه",
    activeOrders: "فعال فرمایشونه",
    busyTables: "بوخت مېزونه",
    expenseToday: "د نن لګښتونه",
    debtToday: "د نن پور",
    profitToday: "د نن اټکلي ګټه",
    itemsSold: "پلورل شوي خواړه",
    salesTrend: "د تېرو ۷ ورځو خرڅلاو",
    topItems: "ډېر پلورل شوي خواړه",
    revenueExpense: "عاید په وړاندې لګښت",
    recentOrders: "وروستي فرمایشونه",
    recentDebtors: "وروستي پوروړي",
    goToCashier: "دخل ته ولاړ شه",
    viewKitchen: "پخلنځی وګوره",
    addExpense: "د لګښت زیاتول",
    addFood: "د خوراک زیاتول",
    addTable: "د مېز زیاتول",
    tableNumber: "د مېز شمېره",
    allSections: "ټولې برخې",
    openOrder: "فرمایش پرانیستل",
    startOrder: "فرمایش پیل کول",
    markClean: "د پاک په توګه نښه کړئ",
    selectTable: "مېز وټاکئ",
    orderType: "د فرمایش ډول",
    customerName: "د پېرودونکي نوم",
    customerPhone: "د پېرودونکي تلیفون",
    addToCart: "ټوکرۍ ته زیاتول",
    sendToKitchen: "پخلنځي ته ولېږه",
    saveDraft: "مسوده خوندي کړه",
    cart: "د فرمایش ټوکرۍ",
    emptyCart: "ټوکرۍ خالي ده",
    allCategories: "ټولې کټګورۍ",
    startPreparing: "چمتو کول پیل کړه",
    markReady: "چمتو په توګه نښه کړه",
    markServed: "وړاندې شو",
    noActiveOrders: "فعال فرمایش نشته",
    elapsed: "تېر شوی وخت",
    applyDiscount: "د تخفیف پلي کول",
    paymentMethod: "د تادیې طریقه",
    receivePayment: "د تادیې ترلاسه کول",
    splitBill: "د بل ویشل",
    printReceipt: "د رسید چاپ",
    receivedAmount: "ترلاسه شوی مقدار",
    change: "بدلون",
    remaining: "پاتې",
    addItem: "د خوراک زیاتول",
    addCategory: "د کټګورۍ زیاتول",
    available_: "شته",
    unavailable: "نشته",
    image: "انځور",
    prepTime: "د چمتو کولو وخت (دقیقې)",
    costPrice: "د لګښت بیه",
    expenseCategory: "د لګښت کټګوري",
    paidBy: "تادیه کوونکی",
    debtorName: "د پوروړي نوم",
    totalDebt: "ټول پور",
    totalPaid: "ټول ورکړل شوی",
    remainingDebt: "پاتې پور",
    addPayment: "د تادیې زیاتول",
    debtHistory: "د پور تاریخچه",
    dailyReport: "ورځنی راپور",
    monthlyReport: "میاشتنی راپور",
    revenue: "عاید",
    grossProfit: "خام ګټه",
    netProfit: "خالصه ګټه",
    profitMargin: "د ګټې حاشیه",
    avgOrder: "د فرمایش اوسط",
    byMethod: "د تادیې طریقې پر اساس",
    byCategory: "د کټګورۍ پر اساس",
    hourlyChart: "ساعتي چارت",
    addUser: "د کارن زیاتول",
    lastLogin: "وروستی ننوتل",
    restaurantInfo: "د ریسټورانټ معلومات",
    receiptSettings: "د رسید تنظیمات",
    financialSettings: "مالي تنظیمات",
    languageSettings: "ژبني تنظیمات",
    restaurantName: "د ریسټورانټ نوم",
    receiptFooter: "د رسید د پای متن",
    receiptWidth: "د حرارتي چاپګر سور",
    taxEnabled: "د مالیې فعالول",
    taxPercent: "د مالیې سلنه",
    serviceEnabled: "د خدمت فعالول",
    servicePercent: "د خدمت سلنه",
    defaultLanguage: "اصلي ژبه",
    empty: "هېڅ شی ونه موندل شو",
    loading: "بارېږي...",
    confirmDelete: "ایا تاسو د حذف کولو ډاډه یاست؟",
    success: "بریالیتوب سره ترسره شو",
    error: "تېروتنه پېښه شوه",
    sessionExpired: "ستاسو ناسته پای ته ورسېده — بیا ننوځئ",
    networkError: "د شبکې تېروتنه — انټرنېټ وګورئ",
    retry: "بیا هڅه",
    loadError: "بارول ناکام شول",
    welcome: "ښه راغلاست",
  },
};

export const roleNames = {
  dari: {
    owner: "مالک",
    manager: "مدیر",
    cashier: "حسابدار",
    waiter: "گارسون",
    kitchen: "آشپزخانه",
    accountant: "حسابدار",
  },
  pashto: {
    owner: "مالک",
    manager: "مدیر",
    cashier: "حسابدار",
    waiter: "ګارسون",
    kitchen: "پخلنځی",
    accountant: "حسابدار",
  },
};

export const expenseCategories = {
  dari: [
    "مواد غذایی",
    "کرایه",
    "معاش کارمندان",
    "برق",
    "آب",
    "گاز",
    "ترمیمات",
    "خرید وسایل",
    "متفرقه",
  ],
  pashto: [
    "د خوړو توکي",
    "کرایه",
    "د کارمندانو معاش",
    "برق",
    "اوبه",
    "ګاز",
    "ترمیمات",
    "د توکو پېرل",
    "متفرقه",
  ],
};

export function fmtAFN(n, lang = "dari") {
  const v = Number(n || 0);
  const formatted = v.toLocaleString(lang === "pashto" ? "ps-AF" : "fa-AF", {
    maximumFractionDigits: 0,
  });
  return `${formatted} ${lang === "pashto" ? "افغانۍ" : "افغانی"}`;
}
